module.exports = __webpack_public_path__ + "img/icn_highlighter.068d1ee9.svg";